import Avatar from '@/components/Avatar'

interface Props {
  firstName: string
  lastName: string | null
  picture: string | null
  headline?: string | null
}

/**
 * Vertical-centered avatar + name (+ optional headline) used at the top of
 * both the QR landing card (OwnerProfile) and the profile access card
 * (BusinessProfile). Single source of truth so the two screens stay
 * visually identical.
 */
export default function ProfileHeader({
  firstName,
  lastName,
  picture,
  headline,
}: Props) {
  const fullName = lastName ? `${firstName} ${lastName}` : firstName

  return (
    <div className="flex flex-col items-center gap-3 text-center">
      <Avatar firstName={firstName} lastName={lastName} picture={picture} />
      <div>
        <h1 className="profile-name">{fullName}</h1>
        {headline && <p className="profile-headline">{headline}</p>}
      </div>
    </div>
  )
}
